import { gql } from '@apollo/client'
import { FeaturedImageFragment } from './FeaturedImage'

export const PostsFragment = gql`
  ${FeaturedImageFragment}
  fragment PostsFeedItemFragment on Post {
    id
    uri
    title
    categories {
      nodes {
        name
      }
    }
    ...FeaturedImageFragment
    postFields {
      blogSliderImage {
        node {
          sourceUrl
          altText
        }
      }
    }
  }
`

export const PostsItemFragment = gql`
  ${FeaturedImageFragment}
  fragment PostsItemFragment on Post {
    id
    date
    uri
    title
    excerpt
    content
    categories {
      nodes {
        name
      }
    }
    ...FeaturedImageFragment
    postFields {
      blogSliderImage {
        node {
          sourceUrl
          altText
        }
      }
    }
  }
`
